import { useSite } from "./use-site";
export var useSiteCreator = function () {
  var site = useSite();
  return site === null || site === void 0 ? void 0 : site.creator;
};